module.exports = __webpack_public_path__ + "static/img/logo.59e9a1a9.png";